import { DeviceTypesProvider } from '@root/src/core/contexts/device-types';
import { SettingsDevicesConfigurationDashboardContainer } from 'modules/settings/pods/settings-devices/settings-devices-configuration/settings-device-configuration-dashboard/settings-device-configuration-dashboard.container';

export const SettingsDevicesConfigurationScene = () => (
    <DeviceTypesProvider>
        <SettingsDevicesConfigurationDashboardContainer />
    </DeviceTypesProvider>
);

export default SettingsDevicesConfigurationScene;
